class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
    this.setHeaderCartIconAccessibility();
  }

  setHeaderCartIconAccessibility() {
    const cartLink = document.querySelector('#cart-icon-bubble');
    cartLink.setAttribute('role', 'button');
    cartLink.setAttribute('aria-haspopup', 'dialog');
    cartLink.addEventListener('click', (event) => {
      event.preventDefault();
      this.open(cartLink)
    });
    cartLink.addEventListener('keydown', (event) => {
      if (event.code.toUpperCase() === 'SPACE') {
        event.preventDefault();
        this.open(cartLink);
      }
    });
  }

  open(triggeredBy) {
    if (triggeredBy) this.setActiveElement(triggeredBy);
    const cartDrawerNote = this.querySelector('[id^="Details-"] summary');
    if (cartDrawerNote && !cartDrawerNote.hasAttribute('role')) this.setSummaryAccessibility(cartDrawerNote);
    // here the animation doesn't seem to always get triggered. A timeout seem to help
    setTimeout(() => {this.classList.add('animate', 'active')});

    this.addEventListener('transitionend', () => {
      const containerToTrapFocusOn = this.classList.contains('is-empty') ? this.querySelector('.drawer__inner-empty') : document.getElementById('CartDrawer');
      const focusElement = this.querySelector('.drawer__inner') || this.querySelector('.drawer__close');
      trapFocus(containerToTrapFocusOn, focusElement);
    }, { once: true });

    document.body.classList.add('overflow-hidden');
  }

  close() {
    this.classList.remove('active');
    removeTrapFocus(this.activeElement);
    document.body.classList.remove('overflow-hidden');
  }

  setSummaryAccessibility(cartDrawerNote) {
    cartDrawerNote.setAttribute('role', 'button');
    cartDrawerNote.setAttribute('aria-expanded', 'false');

    if(cartDrawerNote.nextElementSibling.getAttribute('id')) {
      cartDrawerNote.setAttribute('aria-controls', cartDrawerNote.nextElementSibling.id);
    }

    cartDrawerNote.addEventListener('click', (event) => {
      event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
    });

    cartDrawerNote.parentElement.addEventListener('keyup', onKeyUpEscape);
  }

  renderContents(parsedState) {
    this.querySelector('.drawer__inner').classList.contains('is-empty') && this.querySelector('.drawer__inner').classList.remove('is-empty');
    this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
      const sectionElement = section.selector ? document.querySelector(section.selector) : document.getElementById(section.id);
      sectionElement.innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
    }));

    setTimeout(() => {
      this.querySelector('#CartDrawer-Overlay').addEventListener('click', this.close.bind(this));
      this.open();
    });
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-drawer',
        selector: '#CartDrawer'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionDOM(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector);
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);

class CartDrawerItems extends CartItems {
  getSectionsToRender() {
    return [
      {
        id: 'CartDrawer',
        section: 'cart-drawer',
        selector: '.drawer__inner'
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section'
      }
    ];
  }
}

customElements.define('cart-drawer-items', CartDrawerItems);


(function () {
  const SECTION_KEYS = ['cart-drawer', 'cart-icon-bubble'];

  function getDrawerEl() {
    return document.querySelector('cart-drawer');
  }

  async function fetchSections(keys = SECTION_KEYS) {
    const url = `${location.pathname}?sections=${keys.join(',')}`;
    const res = await fetch(url, { credentials: 'same-origin' });
    if (!res.ok) throw new Error('Failed to load cart sections');
    return res.json(); // { 'cart-drawer': '<html>', 'cart-icon-bubble': '<html>' }
  }

  function setBtnLoading(btn, on) {
    if (!btn) return;
    btn.disabled = !!on;
    const spinner = btn.querySelector('.loading-overlay__spinner');
    if (spinner) spinner.classList.toggle('hidden', !on);
  }

  async function handleAddToCart(form, submitBtn) {
    const fd = new FormData(form);

    const addRes = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: fd,
      credentials: 'same-origin',
    });

    if (!addRes.ok) {
      const err = await addRes.json().catch(() => ({}));
      throw new Error(err?.description || 'Add to cart failed');
    }

    const lineItem = await addRes.json();

    const sections = await fetchSections();

    const drawer = getDrawerEl();
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents({
        id: lineItem?.id || null,
        sections,
      });
    }
  }

  function showFormError(form, message) {
    const wrap = form.closest('.product-form') || form;
    const box = wrap.querySelector('.product-form__error-message-wrapper');
    const msg = wrap.querySelector('.product-form__error-message');
    if (box && msg) {
      msg.textContent = message;
      box.hidden = false;
    } else {
      alert(message);
    }
  }


  document.addEventListener(
    'submit',
    async (e) => {
      const form = e.target;
      if (!form.matches('product-form form, form[action*="/cart/add"]')) return;

      e.preventDefault();

      const submitBtn = form.querySelector('[type="submit"][name="add"]');
      setBtnLoading(submitBtn, true);

      try {
        await handleAddToCart(form, submitBtn);
      } catch (err) {
        showFormError(form, String(err.message || err));
      } finally {
        setBtnLoading(submitBtn, false);
      }
    },
    true
  );

  ['cart:added', 'product:added', 'cart:updated'].forEach((evt) => {
    document.addEventListener(evt, async () => {
      try {
        const sections = await fetchSections();
        const drawer = getDrawerEl();
        if (drawer?.renderContents) {
          drawer.renderContents({ id: null, sections });
        }
      } catch (_) {}
    });
  });
})();
